// extracted by mini-css-extract-plugin
export default {"input":"CustomInput_input__ZUWz0"};